var modules_efad2c92 = {"link":"_aee561"};
import "../../../assets/CVdG8P4s.css";

export { modules_efad2c92 as default };
//# sourceMappingURL=ContactsBanner.module.less.js.map
